import { useMutation, useQueryClient } from "@tanstack/react-query";

import { errorHandler } from "#app/monitoring/errorHandler";
import { showErrorToast } from "#app/notifications";
import { deleteMaterialVolumetricPrice } from "#modules/materials/infra/deleteMaterialVolumetricPrice.api";
import { materialsQuery } from "#modules/materials/infra/materials.query";
import { materialsVolumetricPriceQuery } from "#modules/materials/infra/materialsVolumetricPrice.query";

export const useDeleteMaterialVolumetricPrice = () => {
  const queryClient = useQueryClient();

  const { mutate, ...rest } = useMutation({
    mutationFn: (id: string) => deleteMaterialVolumetricPrice({ id, payload: {} }),
    onSuccess: () => {
      void queryClient.invalidateQueries(materialsQuery());
      void queryClient.invalidateQueries(materialsVolumetricPriceQuery());
    },
    onError: (err: Error) => {
      showErrorToast({ title: err.message });
      errorHandler(err);
    },
  });

  return { deleteMaterialVolumetricPrice: mutate, ...rest };
};
